import giveAxios from '../../utils/giveAxios'
import reporter from '../opportunities/activity-cards/reporter'

const url = '/service/volunteer/tf-update/conclusions'

export const getConclusions = async ({
  advanced = false,
  count = 10,
  countryRepId,
  source = '',
  surname,
  test,
  vpLoggingFF,
}) => {
  const start = Date.now()
  const response = await giveAxios({
    headers: { 'x-source': source },
    method: 'GET',
    params: {
      count,
      countryRepId,
      ...(advanced && { advanced }),
      ...(surname && { surname }),
      ...(test && { test }),
    },
    url,
  })
  const stop = Date.now()

  if (vpLoggingFF?.isOn) {
    const logObject = {
      request: { batchSize: count, placeRepId: countryRepId },
      start,
      status: response.status,
      stop,
      task: 'Verify Places',
    }
    reporter(logObject)
  }
  return response
}

/**
 * @param {Array} conclusions
 * @returns {Promise}
 */
export const putConclusions = async ({ conclusions }) => {
  // Split the array into chunks of 10 because the API can only handle 10 at a time - it puts them in a message queue
  const chunkSize = 10
  const chunks = conclusions.reduce((acc, _, i) => {
    if (i % chunkSize === 0) {
      acc.push(conclusions.slice(i, i + chunkSize))
    }
    return acc
  }, [])
  return Promise.all(
    chunks.map((chunk) => {
      return giveAxios({
        data: chunk,
        method: 'PUT',
        url,
      })
    })
  )
}

export const sessionChecker = async () => {
  try {
    const resp = await giveAxios.get('/service/tree/ftuser/users/CURRENT')
    return resp
  } catch (error) {
    return error
  }
}
